import { Col, Row, Text } from 'components';
import { ProgressBadge, Score } from 'components/Game/components';
import { isToday, isYesterday } from 'date-fns';
import { formatLocale, getRound } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const UserAvatar = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 55px;
  margin-bottom: 13px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const TopSection = ({ data }) => {
  const date = new Date(data.date);
  const { location, score, gameStatus, status, progress, home, dataInfo, away, sport } = data;

  const { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    round = getRound(data.round, dataInfo.leagueId);

  return (
    <Col noFlex bg="#000" pad="24px" wid={isMobile ? 'calc(100% - 32px)' : 'calc(100% - 48px)'}>
      <Col wid="358px" center>
        <Col center>
          <Text col="#fff" b2 center>
            {!isNaN(round) ? t('games.matchday', { round }) : t(`games.${round}`)}
          </Text>

          <Text col="#fff" b2 center>
            {location}
          </Text>
        </Col>

        <Row between marg="24px 0 0">
          <Col noFlex centerAll wid="130px">
            <UserAvatar src={home.avatar} />

            <Text wid="100%" center col="#fff" bold>
              {home.name}
            </Text>
          </Col>

          <Col centerAll>
            {['live', 'finished'].includes(status) ? (
              <Score score={score} sport={sport} />
            ) : (
              <Col center marg="0 0 13px" ht="55px">
                <Text col="#fff" med marg="0 0 2px" center>
                  {isToday(date)
                    ? t('common.today')
                    : isYesterday(date)
                      ? t('common.yesterday')
                      : formatLocale(date, 'MMM dd, iii')}
                </Text>

                <Text col="#fff" med>
                  {formatLocale(date, 'h:mm aa')}
                </Text>
              </Col>
            )}

            <Row noFlex ht="22px">
              <ProgressBadge
                status={status}
                gameStatus={gameStatus}
                progress={progress}
                sport={sport}
              />
            </Row>
          </Col>

          <Col noFlex centerAll wid="130px">
            <UserAvatar src={away.avatar} />

            <Text wid="130px" center col="#fff" bold>
              {away.name}
            </Text>
          </Col>
        </Row>
      </Col>
    </Col>
  );
};

export default TopSection;
